import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {DeviceService} from '../services/device.service';
import {FirmService} from '../services/firm.service';
import {Firms} from '../models/firms';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

declare var $: any;


@Component({
    selector: 'app-firm-device',
    templateUrl: './firm-device.component.html',
    styleUrls: ['./firm-device.component.css']
})
export class FirmDeviceComponent implements OnInit {
    page = 1;
    pages = 2;
    selector: string = '.devices-list';
    manualPassDiv = false;
    manualPassDivUpdate = false;

    protocolWithEspDiv = false;
    protocolWithEspDivUpdate = false;

    hideMqttInputDiv = false;
    hideMqttInputUpdateDiv = false;


    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;
    editForm: FormGroup;
    submitted = false;
    private firmId: string;
    public devices = [];
    public devicesFirstDeactive = [];
    public devicesSecondsActive = [];
    public selectedId;
    public firm: any;
    public searchText;
    public searchDeviceType: number = null ;
    public selectedDevice = {
        name: '',
        firm: new Firms(),
        mac: '',
        serialNumber: '',
        _id: '',
        status: '-1',
        deviceType: 1,
        vpnIpAddress: '',
        user: {username: null, password: null},
        espSsid: '',
        espPassword: '',
        gpioNumber: '',
        virtualSerialNumber: '',
        appMenuPassword: '',
        mqttUser: '',
        mqttPassword: '',
        mqttServerUsername: '',
        mqttServerPassword: '',
    };
    flag: string = '';
    loading = false;
    firms = [];
    firmDetail = [];
    public hideMacInput = false;

    constructor(private deviceService: DeviceService,
                private formBuilder: FormBuilder,
                private router: Router,
                private route: ActivatedRoute,
                private firmService: FirmService,
                private spinner: NgxSpinnerService) {
    }

    ngOnInit() {
        this.spinner.show();
        this.onScroll();
        this.firm = localStorage.getItem('firm');
        this.firmId = localStorage.getItem('firmId');
        this.flag = this.route.snapshot.paramMap.get('flag');
        if (this.flag === 'varliklar') {
            this.getAllDevicesForSuperAdmin();
        } else {
            this.getDeviceByFirm(this.firmId);
        }
        this.getAllFirms();
        this.editForm = this.formBuilder.group({
            editName: ['', [Validators.required]],
            editFirm: ['', [Validators.required]],
            editMac: ['', [Validators.required]],
            editVpn: ['', [Validators.required]],
            editStatus: ['', Validators.required],
            editSerialNumber: [''],
            editVirtualSerialNumber: [''],
            editAppMenuPassword: [''],
            espSsid: [''],
            espPassword: [''],
            gpioNumber: [''],
            editMqttUser: [''],
            editMqttPassword: [''],
            editMqttServerUsername: [''],
            editMqttServerPassword: [''],
        });
    }

    resetSelectedDevice() {
        this.selectedDevice = {
            name: '',
            firm: new Firms(),
            mac: '',
            _id: '',
            serialNumber: '',
            status: '-1',
            deviceType: 1,
            vpnIpAddress: '',
            user: {username: null, password: null},
            espSsid: '',
            espPassword: '',
            gpioNumber: '',
            virtualSerialNumber: '',
            appMenuPassword: '',
            mqttUser: '',
            mqttPassword: '',
            mqttServerUsername: '',
            mqttServerPassword: ''
        };
    }
    // convenience getter for easy access to form fields
    get f() { return this.editForm.controls; }

    onUpdateSubmit() {
        this.submitted = true;
         // stop here if form is invalid
         if (this.editForm.invalid) {
             return;
            }
        if (this.editForm.value.editName === '' || this.editForm.value.editName === undefined || this.editForm.value.editMac === ''
            || this.editForm.value.editMac === undefined || this.editForm.value.editVpn === '' || this.editForm.value.editVpn === undefined
            || this.editForm.value.editStatus === '' || this.editForm.value.editStatus === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        let Device;
        if (this.flag === 'varliklar') {
            Device = {
                name: this.editForm.value.editName,
                mac: this.editForm.value.editMac,
                vpnIpAddress: this.editForm.value.editVpn,
                status: this.editForm.value.editStatus,
                firm: this.editForm.value.editFirm._id,
                serialNumber: this.editForm.value.editSerialNumber,
                espSsid: this.editForm.value.espSsid,
                espPassword: this.editForm.value.espPassword,
                gpioNumber: this.editForm.value.gpioNumber,
                virtualSerialNumber: this.editForm.value.editVirtualSerialNumber,
                appMenuPassword: this.editForm.value.editAppMenuPassword,
                mqttUser: this.editForm.value.editMqttUser,
                mqttPassword: this.editForm.value.editMqttPassword,
                mqttServerUsername: this.editForm.value.editMqttServerUsername,
                mqttServerPassword: this.editForm.value.editMqttServerPassword
            };
        } else {
            Device = {
                name: this.editForm.value.editName,
                mac: this.editForm.value.editMac,
                vpnIpAddress: this.editForm.value.editVpn,
                status: this.editForm.value.editStatus,
                firm: this.firmId,
                serialNumber: this.editForm.value.editSerialNumber,
                espSsid: this.editForm.value.espSsid,
                espPassword: this.editForm.value.espPassword,
                gpioNumber: this.editForm.value.gpioNumber,
                virtualSerialNumber: this.editForm.value.virtualSerialNumber,
                appMenuPassword: this.editForm.value.editAppMenuPassword,
                mqttUser: this.editForm.value.editMqttUser,
                mqttPassword: this.editForm.value.editMqttPassword,
                mqttServerUsername: this.editForm.value.editMqttServerUsername,
                mqttServerPassword: this.editForm.value.editMqttServerPassword
            };
        }

        console.log(Device);
        this.deviceService.updateDevice(Device, this.selectedId).subscribe(res => {
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeUpdateModal.nativeElement.click();
            this.page = 1;
            if (this.flag === 'varliklar') {
                this.getAllDevicesForSuperAdmin();
            } else {
                this.getDeviceByFirm(Device.firm);
            }
            this.resetSelectedDevice();
        }, error => {
            console.log(error);
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else if (error.status === 400 ) {
                this.errorSwal.text = error.message;
                this.errorSwal.show();
                this.spinner.hide();
            } else {
                this.errorSwal.text = error.message;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });

    }
    onReset() {
        this.submitted = false;
        this.resetSelectedDevice();
    }
    onSearchText(e) {
        this.searchText = e;
        this.page = 1;
        this.getAllDevicesForSuperAdmin();
    }

    onSearchDeviceType(e) {
        this.searchDeviceType = e;
        this.page = 1;
        this.getAllDevicesForSuperAdmin();
    }

    getAllDevicesForSuperAdmin() {
        this.flag = this.route.snapshot.paramMap.get('flag');
        if (this.flag === 'varliklar') {
            this.deviceService.getAllDevicesForSuperAdmin(this.page, this.searchText, this.searchDeviceType).subscribe(res => {
                this.devices = [];
                this.devicesFirstDeactive = [];
                this.devicesSecondsActive = [];
                this.pages = res.pages;
                res.docs.forEach(data => {
                    if (!data.status) {
                        this.devicesFirstDeactive.push(data);
                    } else {
                        this.devicesSecondsActive.push(data);
                    }
                });
                this.devices = this.devicesFirstDeactive.concat(this.devicesSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
        }
    }
    getDeviceByFirm(firmId: string) {
        if (firmId) {
            this.deviceService.getDevicesByFirm(firmId).subscribe(res => {
                this.devices = [];
                this.devicesFirstDeactive = [];
                this.devicesSecondsActive = [];
                res.dataDevices.forEach(data => {
                    if (!data.status) {
                        this.devicesFirstDeactive.push(data);
                    } else {
                        this.devicesSecondsActive.push(data);
                    }
                });
                this.devices = this.devicesFirstDeactive.concat(this.devicesSecondsActive);
                this.spinner.hide();
            }, error => {
                if (error.message === 'Error: Access Denied') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    this.router.navigate(['/login']);
                    this.spinner.hide();
                } else {
                    this.errorSwal.title = error.status;
                    this.errorSwal.text = error.error;
                    this.errorSwal.show();
                    this.spinner.hide();
                }
            });
        }
    }

    createDevice(name, mac, vpn, status, selectedDevice) {
        if (name === '' || name === undefined || mac === '' || mac === undefined || vpn === ''
            || vpn === undefined || status === '' || status === '-1') {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        let Device;
        if (this.flag === 'varliklar') {
            Device = {name: name, mac: mac, vpnIpAddress: vpn, status: status, firm: selectedDevice.firm._id};
        } else {
            Device = {name: name, mac: mac, vpnIpAddress: vpn, status: status, firm: this.firmId};
        }
        this.deviceService.createDevice(Device).subscribe(res => {
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.closeCreateModal.nativeElement.click();
            this.page = 1;
            if (this.flag === 'varliklar') {
                this.getAllDevicesForSuperAdmin();
            } else {
                this.getDeviceByFirm(Device.firm);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }


    getDeviceById(id) {
        this.manualPassDivUpdate =  false;
        this.protocolWithEspDivUpdate =  false;
        this.hideMqttInputUpdateDiv =  false;
        this.spinner.show();
        this.deviceService.getDeviceById(id).subscribe(res => {
            if (res.success) {
                this.selectedDevice = res.device;
                this.editForm.controls['editName'].setValue(this.selectedDevice.name);
                this.editForm.controls['editFirm'].setValue(this.selectedDevice.firm);
                this.editForm.controls['editMac'].setValue(this.selectedDevice.mac);
                this.editForm.controls['editVpn'].setValue(this.selectedDevice.vpnIpAddress);
                this.editForm.controls['editStatus'].setValue(this.selectedDevice.status);
                this.editForm.controls['editSerialNumber'].setValue(this.selectedDevice.serialNumber);
                this.editForm.controls['editVirtualSerialNumber'].setValue(this.selectedDevice.virtualSerialNumber);
                this.editForm.controls['editAppMenuPassword'].setValue(this.selectedDevice.appMenuPassword);
                this.editForm.controls['editMqttServerUsername'].setValue(this.selectedDevice.mqttServerUsername || "");
                this.editForm.controls['editMqttServerPassword'].setValue(this.selectedDevice.mqttServerPassword || "");

                this.manualPassDivUpdate = res.device.user ? true : false;
                this.protocolWithEspDivUpdate = res.device.espSsid ? true : false;
                this.hideMqttInputUpdateDiv = res.device.mqttUser ? true : false;

                if (!this.manualPassDivUpdate) {
                    this.selectedDevice.user = {username: null, password: null};
                }
                if (!this.protocolWithEspDivUpdate) {
                    this.selectedDevice.espSsid = null;
                    this.selectedDevice.espPassword = null;
                    this.selectedDevice.gpioNumber = null;
                }
                if (!this.selectedDevice.serialNumber) {
                    this.selectedDevice.serialNumber = '';
                }

                if (!this.selectedDevice.virtualSerialNumber) {
                    this.selectedDevice.virtualSerialNumber = '';
                }

                if (!this.selectedDevice.appMenuPassword) {
                    this.selectedDevice.appMenuPassword = '';
                }

                this.spinner.hide();
            } else {
                this.errorSwal.title = 'Hata';
                this.errorSwal.text = 'Cihazı Alamadım!';
                this.errorSwal.show();
                this.spinner.hide();
            }

        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    selected(id) {
        this.onReset();
        this.selectedId = id;
        this.getDeviceById(id);
    }

    trigggerLog(id, deviceType) {
        if (deviceType !== 2) {
            this.errorSwal.text = 'Bu Cihaz Socket Uyumlu Değil';
            this.errorSwal.show();
            return;
        }
        this.deviceService.triggerLogSocket(id).subscribe(res => {
            this.spinner.hide();

            if (res.success) {
                this.successSwal.text = 'Istel Gönderildi';
                this.successSwal.show();
            } else {
                this.errorSwal.text = 'Otomat Id Bulunamadı';
                this.errorSwal.show();
            }
        });
    }
    deleteDevice(id) {
        if (id === '' || id === undefined) {
            this.errorSwal.title = 'Device id alınamadı!';
            this.errorSwal.show();
            return;
        }
        this.spinner.show();
        this.deviceService.deleteDevice(id).subscribe(res => {
            this.successSwal.title = 'Başarılı!';
            this.successSwal.show();
            this.page = 1;
            if (this.flag === 'varliklar') {
                this.getAllDevicesForSuperAdmin();
            } else {
                this.getDeviceByFirm(id);
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
                this.spinner.hide();
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
                this.spinner.hide();
            }
        });
    }

    getAllFirms() {
        this.firmService.getAllFirms().subscribe(res => {
            if (res.success) {
                this.firms = res.firms;
                for (const firm of this.firms) {
                    this.firmDetail.push(firm._id);
                }
            }
        }, error => {
            if (error.message === 'Error: Access Denied') {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else {
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

    onScroll() {
        if (this.page + 1 > this.pages) { return; }
        $('#page-loader').fadeIn();
        this.page += 1;
        this.deviceService.getAllDevicesForSuperAdmin(this.page, this.searchText, this.searchDeviceType)
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.docs) {
                    this.devices.push(item);
                }
                this.pages = response.pages;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
                this.errorSwal.show();
            });
      }

    createDeviceWithUser(name, mac, vpn, status, selectedDevice, deviceType, serialNumber, espSsid, espPassword,
                         gpioNumber, virtualSerialNumber, appMenuPassword, mqttUser, mqttPassword,
                         mqttServerUsername = null, mqttServerPassword = null) {
        if (name === '' || name === undefined
            || mac === '' || mac === undefined
            || vpn === '' || vpn === undefined
            || status === '' || status === '-1'
            || !deviceType || !serialNumber
        ) {
            this.errorSwal.title = 'Lütfen boş alan bırakmayınız!';
            this.errorSwal.show();
            return;
        }
        let Device;
        let firm = this.firmId;
        if (this.flag === 'varliklar') {
            firm = selectedDevice.firm._id;
        }

        Device = {
            name: name,
            mac: mac,
            vpnIpAddress: vpn,
            status: status,
            firm: firm,
            serialNumber,
            deviceType,
            espSsid,
            espPassword,
            gpioNumber,
            virtualSerialNumber,
            appMenuPassword,
            mqttUser,
            mqttPassword,
            mqttServerUsername,
            mqttServerPassword
        };

        console.log(Device);
        this.spinner.show();
        this.deviceService.createDeviceWithUser(Device).subscribe(res => {
            this.closeCreateModal.nativeElement.click();
            this.page = 1;
            if (this.flag === 'varliklar') {
                this.getAllDevicesForSuperAdmin();
            } else {
                this.getDeviceByFirm(Device.firm);
            }

            this.successSwal.title = 'Başarılı!';
            if (res.data.user) {
                this.successSwal.title = 'Cihaz ile beraber kullanıcı başarıyle oluşturulmuştur';
                this.successSwal.html = `<div>Kullanıcı adı ve parolayı saklayınız</div>
                                         <div><span>Kullanıcı Adı : <b>${res.data.user.username}</b></span> </div>
                                         <div><span>Parola: <b>${res.data.user.password}</b></span> </div>`;
            }
            this.successSwal.show();

        }, error => {
            if (error.message === 'Error: Access Denied') {
                this.spinner.hide();
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                this.router.navigate(['/login']);
            } else if (error.status === 400 ) {
                this.errorSwal.text = error.message;
                this.errorSwal.show();
                this.spinner.hide();
            } else {
                this.spinner.hide();
                this.errorSwal.title = error.status;
                this.errorSwal.text = error.error;
                this.errorSwal.show();
            }
        });
    }

    createDeviceBtn(name, mac = null, vpn, status, selectedDevice, deviceType = null, serialNumber = null, espSsid = null,
                    espPassword = null, gpioNumber = null, virtualSerialNumber = null, appMenuPassword = null, mqttUser = null,
                    mqttPass = null, mqttServerUsername = null, mqttServerPassword = null) {
        if (!mac) {
            mac = serialNumber;
        }
        if (deviceType === '0' || deviceType === 0) {
            this.createDevice(name, mac, vpn, status, selectedDevice);
        } else {
            this.createDeviceWithUser(name, mac, vpn, status, selectedDevice, deviceType,
                serialNumber, espSsid, espPassword, gpioNumber, virtualSerialNumber, appMenuPassword, mqttUser, mqttPass,
                mqttServerUsername, mqttServerPassword);
        }
    }

    checkDeviceType(deviceType: string) {
        console.log((deviceType));
        this.hideMacInput = deviceType === '2';

    }

    showManualPassDiv(event: any) {
        this.manualPassDiv = event.target.checked ? true : false;
    }

    showProtocolWithEsp(event: any) {
        this.protocolWithEspDiv = event.target.checked ? true : false;
    }
    showProtocolWithEspUpdate(event: any) {
        this.protocolWithEspDivUpdate = event.target.checked ? true : false;
    }

    showMqttInput(event: any) {
        this.hideMqttInputDiv = event.target.checked ? true : false;
    }

    showMqttInputUpdate(event: any) {
        this.hideMqttInputUpdateDiv = event.target.checked ? true : false;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-device/firm-device.component.ts